// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import {
	ConsultaPesquisaCivilRequest,
	Types,
	ConsultaPesquisaCivilData,
} from './types';

export function consultaPesquisaCivilRequest(
	token: string,
	payload: ConsultaPesquisaCivilRequest,
) {
	return {
		type: Types.CONSULTA_PESQUISA_CIVIL_REQUEST,
		token,
		payload,
	};
}
export function consultaPesquisaCivilSuccess(
	payload: ConsultaPesquisaCivilData[],
) {
	return {
		type: Types.CONSULTA_PESQUISA_CIVIL_SUCCESS,
		payload,
	};
}
export function consultaPesquisaCivilFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIVIL_FAILURE,
		payload: null,
	};
}

export function consultaPesquisaCivilClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIVIL_CLEAR,
		payload: null,
	};
}
